import script from "./UsersTab.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersTab.vue?vue&type=script&setup=true&lang=js"

import "./UsersTab.vue?vue&type=style&index=0&id=81861626&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81861626"]])

export default __exports__